// eslint-disable-next-line no-restricted-imports
import API from 'api';
// eslint-disable-next-line no-restricted-imports
import { Action, actionCreator } from 'util/actions';

// eslint-disable-next-line no-restricted-imports
import { BoardResponse, MemberResponse, StandardThunkAction } from 'types';
import {
  BOARD_FIELDS,
  BOARD_FIELDS_MINIMAL,
  TEAM_FIELDS_MINIMAL,
} from './fields';

// eslint-disable-next-line no-restricted-imports
import { getMissingBoardIds } from 'selectors';

// Ation types
export const LOAD_MY_BOARDS_REQUEST = Symbol('loaders/LOAD_MY_BOARDS_REQUEST');
export const LOAD_MY_BOARDS_SUCCESS = Symbol('loaders/LOAD_MY_BOARDS_SUCCESS');
export const LOAD_MY_BOARDS_ERROR = Symbol('loaders/LOAD_MY_BOARDS_ERROR');

export const LOAD_MISSING_BOARDS_REQUEST = Symbol(
  'loaders/LOAD_MISSING_BOARD_REQUEST',
);
export const LOAD_MISSING_BOARDS_SUCCESS = Symbol(
  'loaders/LOAD_MISSING_BOARD_SUCCESS',
);
export const LOAD_MISSING_BOARDS_ERROR = Symbol(
  'loaders/LOAD_MISSING_BOARD_ERROR',
);

export type LoadMyBoardsRequestAction = Action<
  typeof LOAD_MY_BOARDS_REQUEST,
  string
>;

export type LoadMyBoardsSuccessAction = Action<
  typeof LOAD_MY_BOARDS_SUCCESS,
  MemberResponse
>;

export type LoadMyBoardsErrorAction = Action<
  typeof LOAD_MY_BOARDS_ERROR,
  Error
>;

export type LoadMissingBoardsRequestAction = Action<
  typeof LOAD_MISSING_BOARDS_REQUEST,
  string[]
>;

export type LoadMissingBoardsSuccessAction = Action<
  typeof LOAD_MISSING_BOARDS_SUCCESS,
  BoardResponse[]
>;
export type LoadMissingBoardsErrorAction = Action<
  typeof LOAD_MISSING_BOARDS_ERROR,
  Error
>;

// Action creators
const loadMyBoardsRequest = actionCreator<LoadMyBoardsRequestAction>(
  LOAD_MY_BOARDS_REQUEST,
);
const loadMyBoardsSuccess = actionCreator<LoadMyBoardsSuccessAction>(
  LOAD_MY_BOARDS_SUCCESS,
);
const loadMyBoardsError = actionCreator<LoadMyBoardsErrorAction>(
  LOAD_MY_BOARDS_ERROR,
);

const loadMissingBoardsRequest = actionCreator<LoadMissingBoardsRequestAction>(
  LOAD_MISSING_BOARDS_REQUEST,
);

const loadMissingBoardsSuccess = actionCreator<LoadMissingBoardsSuccessAction>(
  LOAD_MISSING_BOARDS_SUCCESS,
);

const loadMissingBoardsErrror = actionCreator<LoadMissingBoardsErrorAction>(
  LOAD_MISSING_BOARDS_ERROR,
);

export const loadMyBoards = (idMe: string): StandardThunkAction => {
  return async (dispatch, getState) => {
    try {
      dispatch(loadMyBoardsRequest(idMe));

      const me = await API.client.rest.get<MemberResponse>('members/me', {
        query: {
          boards: 'open,starred',
          board_fields: BOARD_FIELDS,
          board_memberships: 'all',
          organizations: 'all',
          organization_memberships: 'all',
        },
      });

      dispatch(loadMyBoardsSuccess(me));
    } catch (err) {
      dispatch(loadMyBoardsError(err));
    }
  };
};

export const loadBoardsForBoardsMenu = (idMe: string): StandardThunkAction => {
  return async (dispatch, getState) => {
    try {
      dispatch(loadMyBoardsRequest(idMe));

      const me = await API.client.rest.get<MemberResponse>('members/me', {
        query: {
          boards: 'open,starred',
          board_fields: BOARD_FIELDS_MINIMAL,
          boardStars: true,
          organizations: 'all',
          organization_fields: TEAM_FIELDS_MINIMAL,
          board_organization: true,
          board_organization_fields: TEAM_FIELDS_MINIMAL,
          board_myPermLevel: true,
          board_memberships: 'me',
        },
      });

      dispatch(loadMyBoardsSuccess(me));
    } catch (err) {
      dispatch(loadMyBoardsError(err));
    }

    const missingIds = getMissingBoardIds(getState());

    dispatch(loadMissingBoardsRequest(missingIds));

    try {
      const missingBoards = await Promise.all(
        missingIds.map((boardId: string) => {
          return API.client.rest.get<BoardResponse>(`boards/${boardId}`, {
            query: {
              fields: BOARD_FIELDS,
            },
          });
        }),
      );

      dispatch(loadMissingBoardsSuccess(missingBoards));
    } catch (err) {
      dispatch(loadMissingBoardsErrror(err));
    }
  };
};



// WEBPACK FOOTER //
// ./app/gamma/src/modules/loaders/load-my-boards.ts